var React = require('react');

function MapPin (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"d":"M1120.03 306.324c-7.098-7.099-18.607-7.099-25.706 0-6.396 6.395-7.116 18.438-1.688 25.675l14.54 21 14.542-21c5.428-7.237 4.708-19.28-1.688-25.675zm-12.676 18.675a6 6 0 1 1 0-11.999 6 6 0 0 1 0 12z","id":"map-pin-a"})),React.createElement("g",{"transform":"translate(-1085 -297)","fillRule":"nonzero","fill":"none","key":1},[React.createElement("use",{"fill":"currentColor","fillRule":"evenodd","xlinkHref":"#map-pin-a","key":0}),React.createElement("path",{"stroke":"#F0F5F7","strokeWidth":"4","d":"M1121.444 304.91c7.078 7.077 7.918 20.231 1.918 28.228l-16.185 23.375-1.644-2.375-14.497-20.938c-6.044-8.059-5.204-21.213 1.874-28.29 7.88-7.88 20.655-7.88 28.534 0zm-14.09 18.09a4 4 0 1 0 0-8 4 4 0 0 0 0 8z","key":1})])]);
}

MapPin.defaultProps = {"viewBox":"0 0 45 63"};

module.exports = MapPin;

MapPin.default = MapPin;
